export interface ICodeListsRequest {
  source: string;
  codelist: string[];
  localeid: string;
}
